import styled from 'styled-components'

export const LocationContainer = styled.div`
  position: absolute;
  left: 8%;
  top: calc(50%);
  transform: translate(0, -50%);
  box-sizing: border-box;
  z-index: 10;
  width: 310px;
  padding: 25px 25px;
  text-align: center;
  border-radius: 10px;
  box-shadow: 0 1px 6px 1px rgba(186, 186, 186, 0.2);
  border: solid 1px #ffffff;
  background-color: #ffffff;
  @media (max-width: 768px) {
    position: static;
    transform: none;
    margin: 0 auto;
  }
  .locationLogo {
    width: 90px;
    height: 90px;
    object-fit: cover;
    border-radius: 6px;
    box-shadow: 0 10px 5px 0 rgba(147, 147, 147, 0.1);
    z-index: 1;
  }
  p {
    margin: 0;
    margin-top: 20px;
    font-size: 16px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.81;
  }
`
